'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sendHeightScript = require('./sendHeightScript');

var _sendHeightScript2 = _interopRequireDefault(_sendHeightScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHeight = function getHeight(data) {
    if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
        return data;
    }

    try {
        return JSON.parse(data);
    } catch (ex) {
        return { height: 0 };
    }
}; /* global window */

var EmbedHtml = function (_Component) {
    (0, _inherits3.default)(EmbedHtml, _Component);

    function EmbedHtml(props) {
        (0, _classCallCheck3.default)(this, EmbedHtml);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmbedHtml.__proto__ || (0, _getPrototypeOf2.default)(EmbedHtml)).call(this, props));

        _this.messageHandler = _this.messageHandler.bind(_this);
        _this.state = {
            height: 0
        };
        return _this;
    }

    (0, _createClass3.default)(EmbedHtml, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('message', this.messageHandler);

            var doc = this.ref.contentDocument;
            var _props$data = this.props.data;
            _props$data = _props$data === undefined ? {} : _props$data;
            var _props$data$embed = _props$data.embed;
            _props$data$embed = _props$data$embed === undefined ? {} : _props$data$embed;
            var iframeContent = _props$data$embed.html;


            doc.open();
            // fix for bottom margin being cut
            doc.writeln('<style> body { padding-bottom: 1px; } </style>');
            doc.writeln(_sendHeightScript2.default);
            doc.writeln(iframeContent);
            doc.close();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var height = nextState.height;


            return this.state.height !== height;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('message', this.messageHandler);
        }
    }, {
        key: 'messageHandler',
        value: function messageHandler(event) {
            if (this.ref.contentWindow === event.source) {
                var height = getHeight(event.data);

                this.setState(height);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                theme = _props.theme,
                _props$title = _props.title;
            _props$title = _props$title === undefined ? {} : _props$title;
            var titleValue = _props$title.value;


            return _react2.default.createElement('iframe', {
                className: theme.iframeContent,
                title: titleValue,
                height: this.state.height,
                scrolling: 'no',
                ref: function ref(_ref) {
                    _this2.ref = _ref;
                }
            });
        }
    }]);
    return EmbedHtml;
}(_react.Component);

EmbedHtml.propTypes = {
    theme: _propTypes2.default.shape({
        iframeContent: _propTypes2.default.string
    }),
    title: _propTypes2.default.shape({
        value: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        embed: _propTypes2.default.shape({
            html: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired
};
EmbedHtml.defaultProps = {
    title: { value: undefined },
    theme: {}
};
exports.default = EmbedHtml;
//# sourceMappingURL=EmbedHtml.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/EmbedHtml/EmbedHtml.js
 ** module id = 503
 ** module chunks = 1
 **/